import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _isNil from 'lodash/isNil';
import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import v4 from 'uuid/v4';
import MediaConsumer from '@sitebase/media-context/es/MediaConsumer';

import ArrowRight from '@wh/svg-icons/ArrowRight';
import Tick from '@wh/svg-icons/Tick';
import { DrawerItemContentContext } from '../common';
import DrawerItemContext from './DrawerItemContext';
import DrawerLevel from './DrawerLevel';
import Drawer from './Drawer';
import DrawerContext from './DrawerContext';
import { getAllowedAttributes } from '../../props-filters';
import './DrawerItem.scss';

var extractComponentsByGroups = function extractComponentsByGroups(children) {
  var subLevel = null;
  var content = [];

  Children.forEach(children, function (child) {
    if (!child) return;

    if (child.type !== Drawer) content = [].concat(_toConsumableArray(content), [child]);else if (!subLevel) subLevel = child;else if (process.env.NODE_ENV !== 'production') {
      console.warn('DrawerItem has more then one sub-level. First will be used.');
    }
  });
  return { subLevel: subLevel, content: content };
};

var DrawerItem = function (_Component) {
  _inherits(DrawerItem, _Component);

  function DrawerItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DrawerItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DrawerItem.__proto__ || _Object$getPrototypeOf(DrawerItem)).call.apply(_ref, [this].concat(args))), _this), _this.components = {
      subLevel: null,
      content: null
    }, _this.itemId = v4(), _this.itemPath = null, _this.updateDrawerItemContent = function () {}, _this.gatherPath = function (itemId) {
      return [].concat(_toConsumableArray(_this.itemPath), [itemId]);
    }, _this.handleOnClick = function (e, drawerUtils) {
      var onClick = _this.props.onClick;

      var hasSubLevel = Boolean(_this.components.subLevel);
      drawerUtils.toggleActive(_this.itemPath, hasSubLevel);
      if (!_isNil(onClick)) onClick(e);
      if (hasSubLevel) e.stopPropagation();
    }, _this.renderItemLink = function (drawerUtils) {
      var _this$props = _this.props,
          active = _this$props.active,
          className = _this$props.className,
          onClick = _this$props.onClick,
          target = _this$props.target,
          href = _this$props.href,
          rel = _this$props.rel,
          icon = _this$props.icon;
      var _this$components = _this.components,
          subLevel = _this$components.subLevel,
          content = _this$components.content;


      var hasSubLevel = Boolean(subLevel);
      var clickable = hasSubLevel || href || !_isNil(onClick);

      var classNames = cx({
        'sb-header-drawer-item__link': true,
        'sb-header-drawer-item__link--active': drawerUtils.isActive(_this.itemId),
        'sb-header-drawer-item__link--clickable': clickable,
        'sb-header-drawer-item__link--highlighted': active
      }, className);

      var Tag = href ? 'a' : 'span';

      return React.createElement(
        Tag,
        {
          ref: _this.storeLink,
          className: classNames,
          onClick: clickable ? function (e) {
            return _this.handleOnClick(e, drawerUtils);
          } : undefined,
          target: href ? target : undefined,
          href: href,
          rel: rel,
          tabIndex: '0'
        },
        icon && React.createElement(
          'span',
          { className: 'sb-header-drawer-item__icon-wrapper' },
          React.createElement(
            'div',
            { className: 'sb-header-drawer-item__icon' },
            icon
          )
        ),
        React.createElement(
          'span',
          { className: 'sb-header-drawer-item__name' },
          content
        ),
        active && React.createElement(Tick, { className: 'sb-header-drawer-item__tick' }),
        hasSubLevel && React.createElement(ArrowRight, { className: 'sb-header-drawer-item__arrow' })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DrawerItem, [{
    key: 'UNSAFE_componentWillMount',

    // eslint-disable-next-line camelcase
    value: function UNSAFE_componentWillMount() {
      if (this.props.children) {
        this.components = extractComponentsByGroups(this.props.children);
      }
    }

    // eslint-disable-next-line camelcase

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.children === nextProps.children) return;
      if (nextProps.children) {
        this.components = extractComponentsByGroups(nextProps.children);
        this.updateDrawerItemContent(this.itemId, this.components.content);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.updateDrawerItemContent(this.itemId, null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _components = this.components,
          subLevel = _components.subLevel,
          content = _components.content;


      return React.createElement(
        DrawerItemContentContext.Consumer,
        null,
        function (updateDrawerItemContent) {
          if (_this2.updateDrawerItemContent !== updateDrawerItemContent) {
            _this2.updateDrawerItemContent = updateDrawerItemContent;
            updateDrawerItemContent(_this2.itemId, content);
          }
          return React.createElement(
            DrawerItemContext.Consumer,
            null,
            function (_ref2) {
              var gatherPath = _ref2.gatherPath;

              _this2.itemPath = gatherPath(_this2.itemId);
              return React.createElement(
                DrawerItemContext.Provider,
                { value: { gatherPath: _this2.gatherPath } },
                React.createElement(
                  DrawerContext.Consumer,
                  null,
                  function (drawerUtils) {
                    return React.createElement(
                      MediaConsumer,
                      null,
                      function (_ref3) {
                        var device = _ref3.device;
                        return React.createElement(
                          'li',
                          _extends({
                            className: 'sb-header-drawer-item sb-header-drawer-item--' + device
                          }, getAllowedAttributes(_this2.props)),
                          _this2.renderItemLink(drawerUtils),
                          subLevel && React.createElement(DrawerLevel, _extends({}, subLevel.props, {
                            drawerUtils: drawerUtils,
                            below: drawerUtils.isLevelBelow(_this2.itemId),
                            active: drawerUtils.isActive(_this2.itemId),
                            parentPath: _this2.itemPath
                          }))
                        );
                      }
                    );
                  }
                )
              );
            }
          );
        }
      );
    }
  }]);

  return DrawerItem;
}(Component);

DrawerItem.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.node,
  // @fixme: circular dependency on Drawer component
  // elementType(Drawer),
  children: PropTypes.node,
  className: PropTypes.string,
  active: PropTypes.bool
};

export default DrawerItem;
//# sourceMappingURL=DrawerItem.js.map